import React from 'react';
import { useTranslation } from 'react-i18next';
import SubmitModal from 'components/Submits/SubmitModal';

type Props = {
    onDelete: () => void;
    showConfirmationModal: boolean;
    setShowConfirmationModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function AgentConfirmationModal({
    onDelete,
    showConfirmationModal,
    setShowConfirmationModal,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SubmitModal
            submit={onDelete}
            dialogText={t(
                'humanResources.simulation.deleteAgentHypothesisConfirmation',
            )}
            dialogTitle={t('humanResources.simulation.deleteAgentHypothesis')}
            open={showConfirmationModal}
            setOpen={setShowConfirmationModal}
        />
    );
}
